//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './DeviceOverviewClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetDeviceOverviewQueryParameters = {
  serialNumber?: string | null | undefined ;
  maintenanceFrom?: Date | null | undefined ;
  maintenanceTo?: Date | null | undefined ;
  offset?: number | null | undefined ;
  limit?: number | null | undefined ;
  sortBy?: string | null | undefined ;
  sortOrder?: Types.SortOrder | undefined ;
}

export function getUrl(serialNumber?: string | null | undefined, maintenanceFrom?: Date | null | undefined, maintenanceTo?: Date | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): string {
  let url_ = getBaseUrl() + "/api/device-overview?";
if (serialNumber !== undefined && serialNumber !== null)
    url_ += "SerialNumber=" + encodeURIComponent("" + serialNumber) + "&";
if (maintenanceFrom !== undefined && maintenanceFrom !== null)
    url_ += "MaintenanceFrom=" + encodeURIComponent(maintenanceFrom ? "" + Types.formatDate(maintenanceFrom) : "") + "&";
if (maintenanceTo !== undefined && maintenanceTo !== null)
    url_ += "MaintenanceTo=" + encodeURIComponent(maintenanceTo ? "" + Types.formatDate(maintenanceTo) : "") + "&";
if (offset !== undefined && offset !== null)
    url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
if (limit !== undefined && limit !== null)
    url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
if (sortBy !== undefined && sortBy !== null)
    url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
if (sortOrder === null)
    throw new Error("The parameter 'sortOrder' cannot be null.");
else if (sortOrder !== undefined)
    url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDefaultOptions: Omit<UseQueryOptions<Types.ResponseDeviceOverview, unknown, Types.ResponseDeviceOverview>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.ResponseDeviceOverview, unknown, Types.ResponseDeviceOverview>, 'queryFn'>> = {
};
export function getGetDefaultOptions() {
  return getDefaultOptions;
};
export function setGetDefaultOptions(options: typeof getDefaultOptions) {
  getDefaultOptions = options;
}

export function getQueryKey(dto: GetDeviceOverviewQueryParameters): QueryKey;
export function getQueryKey(serialNumber?: string | null | undefined, maintenanceFrom?: Date | null | undefined, maintenanceTo?: Date | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): QueryKey;
export function getQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { serialNumber, maintenanceFrom, maintenanceTo, offset, limit, sortBy, sortOrder,  } = params[0] as GetDeviceOverviewQueryParameters;

    return trimArrayEnd([
        'DeviceOverviewClient',
        'get',
        serialNumber as any,
        maintenanceFrom as any,
        maintenanceTo as any,
        offset as any,
        limit as any,
        sortBy as any,
        sortOrder as any,
      ]);
  } else {
    return trimArrayEnd([
        'DeviceOverviewClient',
        'get',
        ...params
      ]);
  }
}
export function __get(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.get(
      context.queryKey[2] as string | null | undefined,       context.queryKey[3] as Date | null | undefined,       context.queryKey[4] as Date | null | undefined,       context.queryKey[5] as number | null | undefined,       context.queryKey[6] as number | null | undefined,       context.queryKey[7] as string | null | undefined,       context.queryKey[8] as Types.SortOrder | undefined,axiosConfig    );
}

export function useGetQuery<TSelectData = Types.ResponseDeviceOverview, TError = unknown>(dto: GetDeviceOverviewQueryParameters, options?: Omit<UseQueryOptions<Types.ResponseDeviceOverview, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets data.
 * @param serialNumber (optional) Serial number (ytsnr)
 * @param maintenanceFrom (optional) Maintenance from date (ygwvon)
 * @param maintenanceTo (optional) Maintenance to date (ygwbis)
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function useGetQuery<TSelectData = Types.ResponseDeviceOverview, TError = unknown>(serialNumber?: string | null | undefined, maintenanceFrom?: Date | null | undefined, maintenanceTo?: Date | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, options?: Omit<UseQueryOptions<Types.ResponseDeviceOverview, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetQuery<TSelectData = Types.ResponseDeviceOverview, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.ResponseDeviceOverview, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let serialNumber: any = undefined;
  let maintenanceFrom: any = undefined;
  let maintenanceTo: any = undefined;
  let offset: any = undefined;
  let limit: any = undefined;
  let sortBy: any = undefined;
  let sortOrder: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ serialNumber, maintenanceFrom, maintenanceTo, offset, limit, sortBy, sortOrder,  } = params[0] as GetDeviceOverviewQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [serialNumber, maintenanceFrom, maintenanceTo, offset, limit, sortBy, sortOrder, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.ResponseDeviceOverview, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __get(context, axiosConfig) : __get,
    queryKey: getQueryKey(serialNumber, maintenanceFrom, maintenanceTo, offset, limit, sortBy, sortOrder),
    ...getDefaultOptions as unknown as Omit<UseQueryOptions<Types.ResponseDeviceOverview, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets data.
 * @param serialNumber (optional) Serial number (ytsnr)
 * @param maintenanceFrom (optional) Maintenance from date (ygwvon)
 * @param maintenanceTo (optional) Maintenance to date (ygwbis)
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setGetData(queryClient: QueryClient, updater: (data: Types.ResponseDeviceOverview | undefined) => Types.ResponseDeviceOverview, serialNumber?: string | null | undefined, maintenanceFrom?: Date | null | undefined, maintenanceTo?: Date | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined) {
  queryClient.setQueryData(getQueryKey(serialNumber, maintenanceFrom, maintenanceTo, offset, limit, sortBy, sortOrder),
    updater
  );
}

/**
 * Gets data.
 * @param serialNumber (optional) Serial number (ytsnr)
 * @param maintenanceFrom (optional) Maintenance from date (ygwvon)
 * @param maintenanceTo (optional) Maintenance to date (ygwbis)
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.ResponseDeviceOverview | undefined) => Types.ResponseDeviceOverview) {
  queryClient.setQueryData(queryKey, updater);
}